import Page from '~/pages_components/index/index'

export default Page
